import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Note mdxType="Note">
      <p><strong parentName="p">{`Tip:`}</strong>{` If you are using npm 5.2 or higher, we recommend using `}<inlineCode parentName="p">{`npx`}</inlineCode>{` to run packages globally.`}</p>
    </Note>
    <p><a parentName="p" {...{
        "href": "/cli/install"
      }}>{`Installing`}</a>{` a package globally allows you to use the code in the package as a set of tools on your local computer.`}</p>
    <p>{`To download and install packages globally, on the command line, run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install -g <package_name>
`}</code></pre>
    <p>{`If you get an EACCES permissions error, you may need to reinstall npm with a version manager or manually change npm's default directory. For more information, see "`}<a parentName="p" {...{
        "href": "resolving-eacces-permissions-errors-when-installing-packages-globally"
      }}>{`Resolving EACCES permissions errors when installing packages globally`}</a>{`".`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      